import { render, staticRenderFns } from "./index.vue?vue&type=template&id=62496e35&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=62496e35&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62496e35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62496e35')) {
      api.createRecord('62496e35', component.options)
    } else {
      api.reload('62496e35', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=62496e35&scoped=true&", function () {
      api.rerender('62496e35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/map/index.vue"
export default component.exports